<template>
  <f7-page>
    <div>
      <div>
        <div>
          <!-- <div class="notificationDeliv">
            <NotificationDelivery />
          </div> -->
          <div class="card no-margin margin-bottom sampleTable">
            <SamplesConfirmationTable />
          </div>
          <div class="card no-margin margin-bottom orderNumber">
            <div class="OrderNumberField">
              <OrderNumberField />
            </div>
          </div>
          <div class="card no-margin formulario">
            <SamplesConfirmation :store="agencies" />
          </div>
        </div>
      </div>
      <div
        class="content-setting display-flex justify-content-flex-start margin-top gap"
      >
        <f7-button
          class="whiteFontColor"
          style="width: 202px"
          fill
          outline
          type="default"
          styling-mode="contained"
          @click="BackToSamplesRegister"
        >
          {{ this.$t('Add_samples_to_the_delivery_note') }}
        </f7-button>

        <f7-button
          class="color-green whiteFontColor margin-left"
          style="max-width: 200px"
          fill
          outline
          type="default"
          styling-mode="contained"
          name="GoConfirmation"
          @click="GoConfirmation"
        >
          {{ this.$t('finishAndSendSamples') }}
        </f7-button>
      </div>
    </div>
    <DeliveryConfirmationPopUp />
  </f7-page>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SamplesConfirmation from '@/components/SamplesRegister/SamplesConfirmation/SamplesConfirmation.vue';
import SamplesConfirmationTable from '@/components/SamplesRegister/SamplesConfirmation/SamplesConfirmationTable.vue';
import NotificationDelivery from '@/components/SamplesRegister/SamplesConfirmation/NotificationDelivery/index.vue';
import DeliveryConfirmationPopUp from '@/components/SamplesRegister/SamplesConfirmation/DeliveryConfirmationPopUp.vue';
import OrderNumberField from '@/components/SamplesRegister/SamplesConfirmation/OrderNumberField.vue';

export default {
  components: {
    SamplesConfirmation,
    SamplesConfirmationTable,
    NotificationDelivery,
    DeliveryConfirmationPopUp,
    OrderNumberField,
  },
  data() {
    return {
      Customstore: [],
    };
  },
  computed: {
    urlName() {
      if (this.lastRouteGeotoolboxSamples) {
        return 'GisActionsPage';
      }
      return this.lastRouteHome ? 'Home' : 'Home';
    },
    ...mapState('samples', [
      'lastRouteHome',
      'lastRouteGeotoolboxSamples',
    ]),
    ...mapState('samplesRegisterModule', ['agencies']),
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('SamplesList.orderList'),
        disabled: false,
        page: 'SamplesList',
        active: false,
      },
      {
        name: this.$t('SamplesRegister'),
        disabled: false,
        page: 'SamplesRegister',
        active: false,
      },
    ]);
  },
  methods: {
    GoConfirmation() {
      this.setConfirmDeliveryPopup(true);
    },
    BackToSamplesRegister() {
      this.$f7router.navigate(
        {
          name: 'SamplesRegister',
        },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('samplesRegisterModule', [
      'setConfirmDeliveryPopup',
    ]),
  },
};
</script>

<style scoped>
.notificationDeliv {
  width: 100%;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.cardRegister {
  border: 1px solid #00346a;
}
.register {
  width: 85%;
}

.registered {
  width: 14%;
}

.formulario {
  border-left: 4px solid #00346a;
  border-radius: 4px;
  box-shadow: 0 3px 5px #00346a;
}
.sampleTable {
  border-left: 4px solid #00346a;
  border-radius: 4px;
  box-shadow: 0 3px 5px #00346a;
}
.minimum-price {
  color: #00346a;
}

.orderNumber {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0rem;
  width: 60%;
  height: 49px;
  border-left: 4px solid #00346a;
  border-radius: 4px;
  box-shadow: 0 3px 5px #00346a;
}
.buyorder {
  color: #00346a;
  font-size: 20px;
  width: 30%;
  margin-left: 2%;
}
.OrderNumberField {
  width: 100%;
}
</style>
